<div class="panel panel-default">
  <div class="panel-heading">
    Profile
  </div>
  <div class="panel-body">
    <profile-form #profileForm [model]="model" [btnText]="'Update'"></profile-form>
  </div>
</div>